const sales_status_options = [
  { label: "Wyłączona", value: "inactive" },
  { label: "Aktywna", value: "active" },
  { label: "Wstrzymana", value: "paused" },
];

export default sales_status_options